import { render, staticRenderFns } from "./InvoiceTemplateAddEditModal.vue?vue&type=template&id=48357a04&"
import script from "./InvoiceTemplateAddEditModal.vue?vue&type=script&lang=js&"
export * from "./InvoiceTemplateAddEditModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports